

import { useEffect } from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Lecture, serverurl } from "../../api";
import BodyWrapper from "../../components/layouts/BodyWrapper";
import Toast from "../../components/Toast";


const Body = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [lecture, setLecture] = useState({});
    const lectureID = location.pathname.split("/")[2];
    const [offlineMap, setOfflineMap] = useState({});

    useEffect(() => {
        (async () => {
            if (!('caches' in window)) return;
            const cache = await caches.open('offline-videos-v1');
            const keys = await cache.keys();
            const map = {};
            for (const req of keys) {
              if (req.url.includes('/lectures/streamVideo/')) {
                map[req.url] = true;
              }
            }
            setOfflineMap(map);
        })();

        Lecture.lectureDetails({lectureID: lectureID}).then(res => {
            if(res.type === "error") {
                return Toast.fire({icon: "error", title: res.message}).then(() => navigate("/"));
            }
            setLecture(res.lecture);

        })
        .catch(() => {
            return Toast.fire({icon: "error", title: "Network error"}).then(() => navigate("/"));
        })


    }, [])

    const streamUrl = (id) => `${serverurl}/lectures/downloadVideo/${id}`;

    const downloadForOffline = async (id) => {
      const url = streamUrl(id);
      const reg = await navigator.serviceWorker.ready;
    //   reg.active.postMessage({ type: 'CACHE_VIDEO', url });
      if (navigator.serviceWorker && navigator.serviceWorker.controller) {
console.log(id)
        navigator.serviceWorker.controller.postMessage({
          type: "CACHE_VIDEO",
          url: url, // pass the download route
          id: id
        });
      }

    };


  const removeOffline = async (id) => {
    const url = streamUrl(id);
    const reg = await navigator.serviceWorker.ready;
    reg.active.postMessage({ type: 'DELETE_VIDEO', url });
    setOfflineMap((prev) => {
      const copy = { ...prev };
      delete copy[url];
      return copy;
    });
  };

    return (
        <div className="main-content">
            <section className="section">
                <div className="section-header">
                    <h1>Lecture Module</h1>
                </div>

                <div className="section-body">
                    <h2 className="section-title">{lecture.title}</h2>
                    <p className="section-lead">{lecture.name}</p>

                    
                    <div className="row">
                        <div className="col-12">
                            
                        <div className="col-md-10">
                            <div className="card" id="settings-card">
                                <div className="card-header">
                                    <h4>Pro Tip: Pause the video to follow-up at 3-5minutes interval</h4>
                                    <p>{offlineMap[streamUrl(lectureID)] ? 'Available offline' : 'Online only'}</p>
                                    <button className="btn" onClick={() => downloadForOffline(lectureID)} >Download for offline</button>
                                </div>
                                <div className="card-body">
                                    <div className="form-group row align-items-center">
                                        {/* {lecture.url && <iframe width="100%" height="445" src={ lecture.url + "?rel=0"} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen="on" rel="0"></iframe>} */}

                                        {
                                            lecture.url &&
                                        <video id="videoPlayer"  width="95%" height="445" controls autoPlay>
                                            <source src={ serverurl + "/lectures/streamVideo/" + lectureID} type={"video/" + lecture.url.split(".")[1]} />
                                        </video>
                                         }
                                    </div>

                                    <br />
                                    <div className="form-group row ">
                                        <h6 htmlFor="site-description" className="form-control-p col-sm-3 text-md-right">Lecture Notes:</h6>
                                        <div className="col-sm-6 col-md-9">
                                            <p>{lecture.notes}</p>
                                        </div>
                                    </div>

                                    <div className="form-group row ">
                                        <h6 className="form-control-p col-sm-3 text-md-right">Lecture file:</h6>
                                        <div className="col-sm-6 col-md-9">
                                            <p>Submit the file you used to follow up the lecture and mark it as complete to proceed with the next lecture. You'll only be able to proceed to next technology if this is approved.</p>
                                            <div className="form-group">
                                                <input type="file" className="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                        <div className="card-footer text-md-right">
                                            <button className="btn btn-primary" id="save-btn">Mark as completed</button>
                                        </div>
                                </div>
                            </div>

                            
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h4>Questions and Answers on Lecture</h4>
                                </div>
                                <div className="card-body">
                                    <div id="accordion">
                                        <div className="accordion">
                                            <div className="accordion-header" role="button" data-toggle="collapse" data-target="#panel-body-1" aria-expanded="true">
                                                <h4 style={{lineHeight: "2"}}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima minus labore modi cumque, tempora porro ipsum, libero harum sequi nobis optio similique facilis sint vel explicabo dolor provident dignissimos fuga!</h4>
                                            </div>
                                            <div className="accordion-body collapse show" id="panel-body-1" data-parent="#accordion">
                                                <p className="mb-0">
                                                <b>Answer: </b>
                                                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                                                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
                                                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
                                                proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                                            </div>
                                        </div>
                                        <div className="accordion">
                                            <div className="accordion-header" role="button" data-toggle="collapse" data-target="#panel-body-2" >
                                                <h4 style={{lineHeight: "2"}}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima minus labore modi cumque, tempora porro ipsum, libero harum sequi nobis optio similique facilis sint vel explicabo dolor provident dignissimos fuga!</h4>
                                            </div>
                                            <div className="accordion-body collapse " id="panel-body-2" data-parent="#accordion">
                                                <p className="mb-0">
                                                <b>Answer: </b>
                                                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                                                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
                                                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
                                                proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header">
                                    <h4>Ask a question</h4>
                                </div>
                                <div className="card-body">
                                    <div className="form-group">
                                        <textarea className="form-control" cols={150} rows={70} ></textarea>
                                    </div>
                                    <div className="card-footer text-md-right">
                                        <button className="btn btn-primary">Ask question</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
                    
                </div>
            </section>
        </div>
    )
}

const Module = () => {
    return (
        <BodyWrapper children={<Body />} />
    )
}

export default Module;